import gql from 'graphql-tag';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming
const useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery = gql`
	query useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery {
		orgDefaultClassificationLevelId
	}
`;

export function preloadOrgDefaultClassificationLevelIdQuery() {
	return query({
		// Note: we need to use the same name to ensure the preload caching behavior works correctly
		/* @ts-expect-error http://go/cfe-use-relay-artifacts */
		query: useOrgDefaultClassificationLevelIdOrgDefaultClassificationLevelIdQuery,
	});
}
